import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Mask from 'vanilla-masker';
import { uniqueIdentificationGenerator } from '../../utils/uniqueIdentificationGenerator';
import warningIcon from 'images/new-warning-icon.svg';
import errorIcon from 'images/latest-error-icon.svg';
import hintIcon from 'images/hint-icon.svg';
import leadingIcon from 'images/leading-icon.svg';
import processingIcon from 'images/spinner-gray-icon.svg';
import './styles.css';

class TextFieldVersion2 extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    helpText: PropTypes.string,
    successText: PropTypes.string,
    errorText: PropTypes.string,
    warningText: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    validateValue: PropTypes.func,
    mask: PropTypes.string,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    type: PropTypes.string,
    fill: PropTypes.bool,
    rightIcon: PropTypes.string,
    onRightIconClick: PropTypes.func,
    controlledValue: PropTypes.string,
    isControlledValue: PropTypes.bool,
    readOnlyFocus: PropTypes.bool,
    clearIcon: PropTypes.bool,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
    notZero: PropTypes.bool,
    controlled: PropTypes.bool,
    
    // NEW PROPERTIES
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    state: PropTypes.oneOf(['default', 'hover', 'focus', 'processing', 'error', 'warning', 'success']),
    visibleLabel: PropTypes.bool,
    hasLeading: PropTypes.bool,
    hasPlaceholder: PropTypes.bool,
    hasButton: PropTypes.bool,
    hintIcon: PropTypes.element,
    showProcessing: PropTypes.bool,
    // Button: PropTypes.element,
  }

  static defaultProps = {
    size: 'md',
    state: 'default',
    visibleLabel: true,
    hasLeading: false,
    hasPlaceholder: false,
    hasButton: false,
    hintIcon: null,
    showProcessing: false,
  }

  state = {
    value: this.props.value || '',
    isValid: null,
  }

  componentDidUpdate(prevProps) {
    if (
      (this.props.value || this.props.value === '') &&
      this.props.value !== prevProps.value
    ) {
      this.setNewValue(this.props.value);
    }
  }

  setNewValue(value) {
    this.setState({ value, isValid: this.valueIsValid(value) });
  }

  getClasses() {
    const { disabled, readOnly, fill, controlledValue, size, state } = this.props;
    const { isValid, value } = this.state;

    return `
      ${disabled ? 'disabled' : ''}
      ${isValid === false ? 'invalid' : ''}
      ${isValid === true ? 'valid' : ''}
      ${readOnly ? 'read-only' : ''}
      ${fill ? 'full-width' : ''}
      ${value || controlledValue ? 'filled' : ''}
      ${size ? `size-${size}` : ''}
      ${state}
    `;
  }

  onChange(e) {
    const { onChange, mask, notZero = false, controlled = false } = this.props;
    if (notZero && e.target.value === '0') return;
    if (mask) {
      e.target.value = Mask.toPattern(e.target.value, mask);
    }

    if (!controlled) {
      this.setState({
        value: e.target.value,
        isValid: this.valueIsValid(e.target.value),
      });
    }

    if (typeof onChange === 'function') {
      onChange(e);
    }
  }

  onClick(e) {
    const { onClick } = this.props;

    if (typeof onClick === 'function') {
      onClick(e);
    }
  }

  valueIsValid(value) {
    const { required, validateValue } = this.props;

    if (validateValue) {
      return validateValue(value);
    }
    return required && value === '';
  }

  textHelperDisplay() {
    const { errorText, warningText, helpText, error = false, errorMsg } = this.props;
    const { isValid } = this.state;
  
    if (isValid === true) {
      return ['success', null];
    }
  
    if (isValid !== false && helpText) {
      return ['default', <img key='hintIcon' src={hintIcon} />, helpText];
    }
  
    if (errorText) {
      return ['error', <img key='errorIcon' src={errorIcon} />, errorText];
    }
  
    if (error) {
      return ['error', <img key='errorIcon' src={errorIcon} />, errorMsg];
    }
      
    if (warningText) {
      return ['warning', <img key='warningIcon' src={warningIcon} />, warningText];
    }
  
    return ['', null, null];
  }
  
  render() {
    const {
      label,
      name,
      required,
      disabled,
      id,
      placeholder,
      minLength,
      maxLength,
      type,
      controlledValue,
      isControlledValue,
      readOnly,
      visibleLabel,
      hasLeading,
      hasPlaceholder,
      showProcessing,
      hasButton,
    } = this.props;
    const { value } = this.state;

    const customId = id || uniqueIdentificationGenerator('input-text_');
    const customName = name || uniqueIdentificationGenerator('input-text_');
    const classes = this.getClasses();
    const [inputValidationClass, inputSmallIcon, inputSmallText] = this.textHelperDisplay();

    const inputClasses = `input-version2 ${inputValidationClass}`;

    return (
      <div
        className={`text-field-version2-container 
           ${inputValidationClass} ${classes}`}
      >
        {visibleLabel && (
          <label>
            {label}
            {required !== true && <span className='opcional-text'> (opcional) </span>}
          </label>
        )}

        <div className="input-wrapper">
          {hasLeading && (
            <span className="leading-icon">
              <img src={leadingIcon} alt="Leading Icon" />
            </span>
          )}
            <input
            type={type || 'text'}
            id={customId}
            name={customName}
            disabled={disabled}
            required={required}
            className={`${inputClasses} ${this.state.isValid ? 'valid' : ''}`}
            onChange={(e) => this.onChange(e)}
            onClick={(e) => this.onClick(e)}
            value={isControlledValue ? controlledValue : value}
            placeholder={hasPlaceholder ? placeholder : ''}
            minLength={minLength}
            maxLength={maxLength}
            readOnly={readOnly}
            autoComplete={isControlledValue ? 'off' : 'on'}
            style={{ 
              paddingLeft: hasLeading ? '40px' : '10px',
              borderColor: (value || controlledValue) ? '#add585' : undefined
            }}
          />

          {showProcessing && (
            <span className="processing-icon">
              <img src={processingIcon} alt="Processing Icon" />
            </span>
          )}

          {hasButton && (
            <button className="action-button">
              Action
            </button>
          )}
        </div>
    
        {inputSmallText && (
          <small className={inputValidationClass}>
            {inputSmallIcon}
            {inputSmallText}
          </small>
        )}
      </div>
    );
  }
}

export default TextFieldVersion2;
